import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SampleDataSate } from '../reducers/sampleData.reducer';

export const sampleDataSate: any = createFeatureSelector<SampleDataSate>('sampleData');

export const sampleDataTable = createSelector(sampleDataSate, (state: any) => state.sampleDataTable);
